import React from 'react';
import { AuditLogViewer } from '../components/audit/AuditLogViewer';

const AuditLog: React.FC = () => {
  return <AuditLogViewer />;
};

export default AuditLog;